import {DiGithubAlt} from 'react-icons/di'
import {BsTelegram} from 'react-icons/bs'
import {FaLinkedin} from 'react-icons/fa'
const SocialLinks = props => {
    return (
      <div className="social">
        <a
          href="https://github.com/Emanuel-js"
          target="_blank"
          rel="noopener noreferrer"
          title=""
        >
         
        <DiGithubAlt/>
        </a>
        
        <a
          id="profile-link"
          href="https://t.me/Upriser"
          target="_blank"
          rel="noopener noreferrer"
          title="Link to author's GitHub Profile"
        >
          {' '}
         <BsTelegram/>
        </a>
        <a
          href="https://www.linkedin.com/in/emanuel-awol/"
          target="_blank"
          rel="noopener noreferrer"
          title="Link to author's Codepen Profile"
        >
          {' '}
         <FaLinkedin/>
        </a>
      </div>
    );
  };
  
  export default SocialLinks;